import React from 'react';
import { Link } from 'react-router-dom';
import { fmtDate } from '../api';

export default function SourcePicker({ id, title, items, selected, onToggle, empty, describe }) {
  return (
    <div className="border border-[#1F242C] min-w-0" data-testid={`dossier-src-${id}`}>
      <div className="px-4 py-3 border-b border-[#1F242C] flex items-center justify-between">
        <p className="text-sm text-[#E5E5E5]">{title}</p>
        <span className="text-[11px] font-mono text-[#5A5F67]" data-testid={`dossier-src-${id}-count`}>{selected.length} selezionati</span>
      </div>
      {!items.length && <p className="px-4 py-4 text-xs text-[#5A5F67]">{empty}</p>}
      <div className="max-h-64 overflow-y-auto divide-y divide-[#1F242C]">
        {items.map((it) => {
          const d = describe(it);
          return (
            <label key={it.id} className={`px-4 py-3 flex items-start gap-3 ${d.disabled ? 'opacity-60' : 'cursor-pointer hover:bg-[#D4AF37]/[0.04]'} transition-colors`} data-testid={`dossier-item-${id}-${it.id}`}>
              <input type="checkbox" disabled={d.disabled} checked={selected.includes(it.id)} onChange={() => onToggle(it.id)} className="mt-0.5 accent-[#D4AF37]" data-testid={`dossier-check-${id}-${it.id}`} />
              <div className="min-w-0 flex-1">
                <p className="text-sm truncate">{d.label}</p>
                <p className="text-xs text-[#5A5F67]">{fmtDate(it.created_at)} · {d.sub}</p>
                {d.warn && <p className="text-xs text-[#D9822B] mt-0.5">{d.warn} {d.link && <Link to={d.link} className="underline">Apri</Link>}</p>}
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
}
